import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import Avatar from "../Form/Avatar";
import UserInfo from "../Form/UserInfo";
 
export default function LandLordTopBar({ title, user }) {
  const [showUserSidebar, setShowUserSidebar] = useState(false);
 
  // Only open sidebar if screen is small
  const handleAvatarClick = () => {
    if (window.innerWidth < 640) {
      setShowUserSidebar(true);
    }
  };
 
  // Auto-close sidebar if resizing to >=sm
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 640) {
        setShowUserSidebar(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  return (
    <>
      <div className="flex items-center justify-between w-full h-[4.9375rem] pr-2 md:pr-6  lg:pr-[30px] pl-16 md:pl-16 lg:pl-4 bg-white drop-shadow-[0_5px_5px_rgba(0,0,0,0.05)]">
        <h1 className="ml-3 font-bold text-transparent text-level-5 sm:text-level-4 md:text-level-3 xl:text-level-2 font-alexandria bg-main-header-gradient bg-clip-text">
          {title}
        </h1>
        <div className="flex items-center gap-4">
          {/* Avatar is always visible, only clickable on small screens */}
          <button
            className="w-14 h-14 sm:cursor-default focus:outline-none"
            // onClick={handleAvatarClick}
            aria-label="Show user info"
            type="button"
            tabIndex={window.innerWidth < 640 ? 0 : -1}
          >
            <Avatar profilePicture={user.profilePicture} userName={user.name} size={48} />
          </button>
          {/* User info and Account Setting: hidden on small screens */}
          <div className="flex-col hidden sm:flex">
            <UserInfo userName={user.name} />
            <span className="font-normal text-level-7 font-inter text-[#718096]">
              Account Setting
            </span>
          </div>
        </div>
      </div>
 
      {/* Overlay with fade-in animation */}
      <div
        className={`
          fixed inset-0 bg-black bg-opacity-30 z-40 sm:hidden transition-opacity duration-300
          ${showUserSidebar ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
        `}
        onClick={() => setShowUserSidebar(false)}
      />
 
      {/* Sidebar with slide-in animation */}
      <div
        className={`
          fixed top-0 right-0 h-full w-[330px] bg-white z-50 shadow-lg flex flex-col p-6 sm:hidden
          transition-transform duration-300
          ${showUserSidebar ? "translate-x-0" : "translate-x-full"}
        `}
        style={{ willChange: "transform" }}
      >
        <button
          className="self-end mb-4"
          onClick={() => setShowUserSidebar(false)}
          aria-label="Close"
        >
          <X size={28} />
        </button>
        <div className="flex flex-col items-start gap-3">
          <Avatar profilePicture={user.profilePicture} userName={user.name} size={64} />
          <UserInfo userName={user.name} />
          <button
            type="button"
            className="mt-2 font-normal text-level-7 font-inter text-sidebar-content"
          >
            Account Setting
          </button>
        </div>
      </div>
    </>
  );
}